export const isCasinoGamePage = () => /^\/casino\/game\/?$/.test(window.location.pathname);
